/* FÉNIX R07.96 — sticky ATC / floating-stack authority.
   The sticky control remains a proxy of the native PDP purchase button.
   R07.96 bridges its real visible state to the global floating coordinator so
   Shopify Inbox / ProveSource can reserve safe space without overlapping it. */
(function(){
  'use strict';

  function init(){
    var body=document.body;
    if(!body || !body.classList.contains('template-product')) return;

    var bar=document.getElementById('nmStickyATC');
    var stickyButton=document.getElementById('nmStickyAdd');
    var nativeButton=document.getElementById('AddToCart');
    if(!bar || !stickyButton || !nativeButton) return;

    var nativePrice=document.getElementById('ProductPrice');
    var stickyPrice=bar.querySelector('[data-nm-sticky-price]');
    var targets=[nativeButton,document.querySelector('.nm-pdp-secondary-ctas')].filter(Boolean);
    var visible=new Set();
    var lastActive=null;

    function isInViewport(el){
      if(!el) return false;
      var r=el.getBoundingClientRect();
      return r.bottom>0 && r.top<window.innerHeight && r.right>0 && r.left<window.innerWidth;
    }

    function notifySticky(active){
      try{
        window.dispatchEvent(new CustomEvent('nm:sticky-atc-change',{detail:{active:active}}));
      }catch(e){
        try{window.dispatchEvent(new Event('nm:sticky-atc-change'));}catch(_e){}
      }
    }

    function syncVisibility(forceNotify){
      var suppressed=visible.size>0;
      body.classList.toggle('nm-r181-sticky-suppressed',suppressed);

      /* Compatibility bridge expected by nm-v70-9-floating-runtime.js. */
      var active=body.classList.contains('nm-r181-sticky-ready') && !suppressed;
      bar.classList.toggle('is-visible',active);

      if(forceNotify || lastActive!==active){
        lastActive=active;
        notifySticky(active);
      }
    }

    function fallbackVisibility(){
      visible.clear();
      targets.forEach(function(el){ if(isInViewport(el)) visible.add(el); });
      syncVisibility(false);
    }

    function nativeUnavailable(){
      return !!(nativeButton.disabled || nativeButton.getAttribute('aria-disabled')==='true' || nativeButton.classList.contains('disabled'));
    }

    function syncCommerce(){
      var unavailable=nativeUnavailable();
      stickyButton.disabled=unavailable;
      stickyButton.setAttribute('aria-disabled',unavailable?'true':'false');
      stickyButton.textContent=unavailable ? (nativeButton.textContent.replace(/\s+/g,' ').trim() || 'Agotado') : 'Agregar al carrito';
      if(stickyPrice && nativePrice){
        var price=nativePrice.textContent.replace(/\s+/g,' ').trim();
        if(price) stickyPrice.textContent=price;
      }
    }

    stickyButton.addEventListener('click',function(event){
      event.preventDefault();
      if(nativeUnavailable()) return;
      syncCommerce();
      nativeButton.click();
    });

    var commerceObserver=new MutationObserver(syncCommerce);
    commerceObserver.observe(nativeButton,{attributes:true,attributeFilter:['disabled','aria-disabled','class'],childList:true,subtree:true,characterData:true});
    if(nativePrice){
      commerceObserver.observe(nativePrice,{childList:true,subtree:true,characterData:true});
    }

    var variantSelect=document.getElementById('productSelect');
    if(variantSelect){
      variantSelect.addEventListener('change',function(){
        window.setTimeout(syncCommerce,0);
        window.setTimeout(syncCommerce,80);
      });
    }

    fallbackVisibility();

    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting && entry.intersectionRatio>0.04) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        syncVisibility(false);
      },{threshold:[0,.04,.15,.5]});
      targets.forEach(function(el){observer.observe(el);});
    }else{
      window.addEventListener('scroll',fallbackVisibility,{passive:true});
      window.addEventListener('resize',fallbackVisibility,{passive:true});
    }

    syncCommerce();
    bar.style.removeProperty('display');
    bar.setAttribute('data-nm-sticky-ready','true');
    body.classList.add('nm-r181-sticky-ready');
    syncVisibility(true);
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
